import React, {Component, Fragment} from 'react';
import style from '../css/openBet.css';
import {connect} from 'react-redux';
// helpers
import {
    getDecimalSeparator,
    getFormattedCurrency,
    getText,
    usingNonDecimalCurrency
} from '../../../helpers/localization';
// import {hasEventTypeRacerNumberUI} from '../modules/racing/helpers/racersHelper';
// constants
import {ASSETS_URL} from '../../../constants/endpoints';
// import {VIRTUALS} from '../../../constants/games';
//action
import {removeOpenBet, updateOpenBetStake} from '../actions/openBetsActions';
import {getOddsFromOddsType} from "../../../helpers/oddsHelpers";
import {getItem, setItem} from "../../../helpers/localStorageHelpers";
import {DEFAULT_STAKES, OPTED_CAMPAING_IDS} from "../../../constants/localStorage";
import {getPromoBalances, isBetValid} from "../helpers/betHelpers";
import {hasVirtualKeyboard} from "../../../helpers/layoutHelpers";
import {ENABLED, GOLD, JPY, MATCHDAY_MODULE, RACING_MODULE, SILVER} from "../../../constants/identifiers";
import device from "current-device";
import {getModuleFromEventType} from './../../../helpers/moduleHelpers';
import {BASE_VALUE} from "../../../constants/chips";
import OpenBetOverlay from './openBetOverlay';
import {getPotentialReturn, isMatchDay, isSingleBetOrPartOfAccaBet} from "../modules/matchday/helpers/matchdayHelper";
import { openCloseMyOfferList,applyPromoBet,setSetectedBet,removePromoBet } from '../../../actions/promoBetActions';
import {OPERATOR} from "../../../constants/operator";
import { isBaseBall } from '../modules/baseball/helpers/marketHelpers';
/* global BMS*/

const mapStateToProps = (state, ownProps) => {
    return {
        openBetsList: state.vpp.openBetsList,
        selectedOddsType: state.vpp.selectedOddsType,
        games: state.vpp.games,
        betsCommitting: state.vpp.betsCommitting,
        promoBalances: state.vpp.promoBalances
    };
};

class OpenBet extends Component {

    constructor(props) {
        super(props);
        this.stakeInput = React.createRef();

        let store = this.props.store;
        let storeData = store.getState();

        let isDisabled = this.props.betSelection.bets[0].hasExpired ||
            storeData.vpp.games.find(g => g.channel === this.props.betSelection.bets[0].game.channel).state.toString() !== ENABLED;

        this.isDisabled = isDisabled;
        this.state = {
            openBetsList: storeData.vpp.openBetsList,
            selectedOddsType: storeData.vpp.selectedOddsType,
            games: storeData.vpp.games,
            isDisabled: isDisabled,
            placeholder: 'STAKE',
            betsCommitting: storeData.vpp.betsCommitting,
            placeholderHidden: false,
            promoBalances: storeData.vpp.promoBalances
        };

    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        let isDisabled = this.props.betSelection.bets[0].hasExpired ||
            storeData.vpp.games.find(g => g.channel === this.props.betSelection.bets[0].game.channel).state.toString() !== ENABLED;

        if (nextProps && storeData) {
            this.setState({
                openBetsList: storeData.vpp.openBetsList,
                selectedOddsType: storeData.vpp.selectedOddsType,
                games: storeData.vpp.games,
                betsCommitting: storeData.vpp.betsCommitting,
                isDisabled: isDisabled,
                promoBalances: storeData.vpp.promoBalances
            });
        }

    }

    _getCloseButtonUI() {
        return (<div
                id={'closeButton_' + this.props.index}
                className={style.closeButtonContainer}
                onClick={() => this.props.store.dispatch(removeOpenBet(this.props.betSelection))}>
                <div className={style.closeButtonWrap}>
                    <div className={style.closeButton} alt={'close'}></div>
                </div>
            </div>
        );
    }

    _getGiftButtonUI(){
        return (<div
            id={'giftButton_' + this.props.index}
            className={style.giftIconContainer}
            >
            <img onClick={(event) => this._setSetectedBet(event)}
                className={style.giftIconContainerBox} src={`${ASSETS_URL}promo/giftIconWhite.png`} alt='gift' />
        </div>
    );
    }

    _getDeleteButtonUI(){
        return (<div
            id={'giftButton_' + this.props.index}
            className={style.giftIconContainer}
            >
            <img onClick={(event) => this._removePromoBet(event)}
                className={style.deleteContainerBox} src={`${ASSETS_URL}promo/deleteIconBetSlip.png`} alt='gift' />
        </div>
    );
    }

    _applyPromoBet(event){
        event.stopPropagation();
        this.props.store.dispatch(openCloseMyOfferList());
        this.props.store.dispatch(applyPromoBet(this.props.betSelection));
    }

    _setSetectedBet(event){
        event.stopPropagation();
        //save selected bet in redux store to update the the data with prombet once player selected from list
        this.props.store.dispatch(setSetectedBet(this.props.betSelection));
        this.props.store.dispatch(openCloseMyOfferList());
    }

    _removePromoBet(event){
        event.stopPropagation();
        this.props.store.dispatch(removePromoBet(this.props.betSelection,(process.env.NODE_ENV !== 'development' && BMS && BMS.authentication && BMS.authentication.isPlayerLogged && this.state.playerBalance)
        ? this.state.playerBalance.Banks.CREDIT.MinorCurrencyUnits
        : 2,this.props.store.getState().vpp.systemLanguage, this.props.store.getState().vpp.systemCurrency));
    }

    _getPotentialReturns(stake) {
        let potentialReturns = getPotentialReturn(this.props.odd, stake, 1, 0);
        if (usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) {
            potentialReturns = Math.round(potentialReturns);
        } else {
            potentialReturns = potentialReturns.toFixed(2);
            potentialReturns = potentialReturns.replace('.', '');
        }
        potentialReturns = getFormattedCurrency(this.props.store, potentialReturns);

        return potentialReturns;
    }

    _isFreeBetexsist() {
        let isFreeBetExist = false;
        if(OPERATOR.promoToolEnabled) {
            let storeData = this.props.store.getState();
            //ValidPromos are promos that are opted in by player
            let validPromos = getPromoBalances(this.state.promoBalances, getItem(storeData.vpp.playerUID, OPTED_CAMPAING_IDS));
            //To show the gift icon in the remaining betslip, this logic is used to find any promo bets that remain
            if (validPromos.length >= 1) {
                var totalFreeBetCount = validPromos.map(offer => offer.PromoBetCnt).reduce((fc1, fc2) => fc1 + fc2,0);
                isFreeBetExist = totalFreeBetCount > 0 ? true : false;
            }
        }
        return isFreeBetExist;
    }

    render() {
        if (this.state.openBetsList[this.state.openBetsList.indexOf(this.props.betSelection)] === undefined) {
            return '';
        }
        let currentStake = this.state.openBetsList[this.state.openBetsList.indexOf(this.props.betSelection)].stake;
        let stake = currentStake ? currentStake : '';
        if (stake)
            stake = stake.replace('.', getDecimalSeparator(this.props.store));

        let eventInfo;
        if (this.props.betSelection.bets[0].event.eventType !== undefined) {
            switch (getModuleFromEventType(this.props.betSelection.bets[0].event.eventType)) {
                case RACING_MODULE:
                    eventInfo = (
                        <div className={style.event}
                             id={'eventDate_' + this.props.index}>{`${this.props.eventName.dayMonthYear}  ${this.props.eventName.hoursMinutes}`}</div>
                    )
                    break;
                case MATCHDAY_MODULE:
                    eventInfo = (<Fragment>
                        <div className={style.event}
                             id={'eventDate_' + this.props.index}>{`${this.props.eventName.dayMonthYear}  ${this.props.eventName.hoursMinutes}  ${getText('MD', this.props.store, [this.props.leagueDay])}`}</div>
                        <div className={style.event}
                             id={'eventName_' + this.props.index}>{this.props.eventName.gameTitle}</div>
                    </Fragment>)
                    break;
                                default:
                    eventInfo = (<Fragment>
                        <div className={style.event}
                             id={'eventDate_' + this.props.index}>{`${this.props.eventName.dayMonthYear}  ${this.props.eventName.hoursMinutes}`}</div>
                        <div className={style.event}
                             id={'eventName_' + this.props.index}>{this.props.eventName.gameTitle}</div>
                    </Fragment>)

                    break;
            }
        }


        let names = this.props.names.map((name, index) => {
            return (<div key={index} id={'name_' + this.props.index + '_' + index} className={style.name}>{name}</div>);
        });

        let bottomContainer;
        if ((this.props.odd !== undefined && this.props.odd !== '') || this.props.potentialReturns !== undefined) {
            let potentialReturns = this.props.potentialReturns !== undefined ? this.props.potentialReturns : getFormattedCurrency(this.props.store, 0);
            if (Number(stake ? stake.replace(getDecimalSeparator(this.props.store), '.') : 0) && Number(this.props.odd) && this.props.potentialReturns === undefined) {
                if (this.props.store != undefined && usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) {
                    potentialReturns = this._getPotentialReturns(stake ? stake.replace(getDecimalSeparator(this.props.store), '.') : 0);
                } else {
                    potentialReturns = getFormattedCurrency(this.props.store, getPotentialReturn(this.props.odd, stake ? stake.replace(getDecimalSeparator(this.props.store), '.') : 0, 1, 0,this.props.betSelection.promo=='applied'?stake.replace(getDecimalSeparator(this.props.store), '.'):0));
                }
            }
            if (this.props.potentialReturns !== undefined && usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) {
                potentialReturns = Math.round(potentialReturns);
                potentialReturns = (this.props.store.getState().vpp.systemCurrency.toUpperCase() === JPY ) ? String.fromCharCode(165) + potentialReturns : potentialReturns;
            }

            //logic
            // if(this.props.betSelection.promo=='applied'){
            //     potentialReturns = potentialReturns - getFormattedCurrency(this.props.store, 2)
            // }
            let potentialReturnsUI = (
                <div className={style.potentialReturnsContainer}>
                    <div className={style.potentialReturnsLabel}>{getText('POT_RETURNS', this.props.store)}
                    </div>
                    <div id={'potential_returns_value_' + this.props.index}
                         className={style.potentialReturnsText}>{potentialReturns.toString()}</div>
                </div>
            );

            bottomContainer = (<div className={style.bottomContainer}>
                {potentialReturnsUI}
            </div>);
        }
        let checkBox = this.props.checkBox;

        let overlay;
        if (this.props.betSelection.bets[0].hasExpired) {
            if (document.activeElement.id === "stakeInput_" + this.props.index) {
                document.activeElement.blur();
            }

            overlay = <OpenBetOverlay store={this.props.store} betSelection={this.props.betSelection}/>

        } else if (this.state.games.find(g => g.channel === this.props.betSelection.bets[0].game.channel).state.toString() !== ENABLED) {

            overlay =
                <OpenBetOverlay store={this.props.store} betSelection={this.props.betSelection} gameDisabled={true}/>
        }
        if (overlay) {
            this.disableOnNextUpdate = true;
        }

        let multiplier;
        if (this.props.betSelection.bets[0].externalRefId !== undefined) {
            multiplier = (<div className={style.multiplier}>
                <div className={style.multiplierValue}>x2</div>
            </div>);
        }

        let openBetContainerStyle = this.props.store.getState().vpp.hasTouchScreen ?
            `${style.openBetContainer} ${style.touchScreen}` :
            style.openBetContainer;
        openBetContainerStyle = this.props.betSelection.promo=='applied' ? `${openBetContainerStyle} ${style.openBetContainerPromo}`:openBetContainerStyle;

        let odd = getOddsFromOddsType(this.props.odd, this.state.selectedOddsType);

        let showVirtualKeyboard = hasVirtualKeyboard(this.props.store, device.desktop());
        let onChangeHandler = !showVirtualKeyboard ?
            (evt) => this.updateInputValue(evt.target.value) :
            undefined;

        let inputOptions = {};
        if (this.state.isDisabled || this.state.betsCommitting) {
            inputOptions['disabled'] = 'disabled';
        }

        let gameName = (this.props.betSelection.bets[0].game.gameCategory + '_' + this.props.betSelection.bets[0].game.name).replace(/\s+/g, '_');
        let gameNameDiv = isMatchDay(this.props.betSelection.bets[0].event.eventType) ? (
                <div className={style.eventName}>{getText(gameName, this.props.store)}
                    <img className={style.betSlipImg}
                         src={`${ASSETS_URL}${this.props.betSelection.bets[0].game.assetsPath}/betslipIcon.png`}/>
                </div>
            ) :isBaseBall(this.props.betSelection.bets[0].event.eventType)?(<div className={style.eventName}>{getText(gameName+'_SHORT', this.props.store)}</div>):
            (<div className={style.eventName}>{getText(gameName, this.props.store)}</div>);

        let placeholderStyle = this.state.placeholderHidden || stake || this.props.betSelection.promo=='applied' ? style.noDisplay : style.placeholder
        placeholderStyle += multiplier ? " " + style.multiplierPlaceholder : "";
        let oddToDisplay;
        if (this.props.store != undefined)
            oddToDisplay = odd;

        let inValidAccaBetContainerStyle = isMatchDay(this.props.betSelection.bets[0].event.eventType) ?
            isSingleBetOrPartOfAccaBet(this.props.betSelection.bets[0], this.state.openBetsList) ?
                style.inValidAccaBetContainer
                : `${style.inValidAccaBetContainer} ${style.highlightInvalidAcca}` : '';

        let inValidAccaBetIndicator =
            (<div className={inValidAccaBetContainerStyle}>
            </div>);

        return (
            <div className={openBetContainerStyle}>
                <div className={style.topContainer}>
                    
                    <div className={style.middleContainer}>
                        <div className={style.betType} id={'betType_' + this.props.index}>{this.props.betType}</div>
                        <div className={style.names}>{names}</div>
                        {eventInfo}
                        <div className={style.checkBox} id={'eachWayCheckBox_' + this.props.index}>{checkBox}</div>
                    </div>
                    {/*<div className={style.centerContainer}>{silks}</div>*/}
                    <div className={style.rightContainer}>
                        <div className={style.rightMainContainer}>
                            {gameNameDiv}
                            <div className={style.oddStakeContainer}>
                                <div className={style.oddsContainer}>
                                    <div className={style.oddLabel}>{`${getText('ODDS', this.props.store)}: `}</div>
                                    <div className={style.odd}
                                         id={'odd_' + this.props.index}>{oddToDisplay}</div>
                                </div>
                                <div className={style.stake}>
                                    <input
                                        disabled={this.props.store.getState().vpp.quickFillBoxChecked || this.props.betSelection.promo=='applied'}
                                        id={'stakeInput_' + this.props.index}
                                        className={style.stakeInput}
                                        type={'text'}
                                        name='stakeInput'
                                        autoFocus={this.props.isEnabled}
                                        autoComplete='off'
                                        readOnly={showVirtualKeyboard}
                                        value={stake}
                                        onKeyPress={(evt) => {
                                            this.handleKeyPress(evt)
                                        }}
                                        onContextMenu={(event) => this._preventRoolbackToPreviousAmount(event)}
                                        onChange={onChangeHandler}
                                        onBlur={(evt) => this.formatInputValue(evt.target.value, 'stakeInput_' + this.props.index)}
                                        onFocus={() => this.onFocus()}
                                        {...inputOptions}
                                        ref={this.stakeInput}/>
                                    <div className={placeholderStyle} onClick={() => {
                                        this.onFocus();
                                        this.stakeInput.current.focus()
                                    }}>{getText('STAKE', this.props.store)}</div>
                                    {multiplier}
                                </div>
                            </div>
                            {bottomContainer}
                        </div>
                        {inValidAccaBetIndicator}
                    </div>
                    <div className={style.leftContainer}>
                        <div className={style.closeIconContaine}>{this._getCloseButtonUI()}</div>
                        {
                        this.props.betSelection.promo=='applied'  ? this._getDeleteButtonUI():this._isFreeBetexsist()?this._getGiftButtonUI():''
                        }
                    </div>
                </div>

                {overlay}
            </div>
        );
    }

    handleKeyPress(evt) {
        //accept only numbers, (dots and commas, if decimal currency)
        let storeData = this.props.store.getState();
        let systemCurrency = storeData.vpp.systemCurrency;
        var regex = usingNonDecimalCurrency(systemCurrency) ?
            /^(\d)$/ : getDecimalSeparator(this.props.store) === '.' ?
                /^\d{0,100}(?:\.\d{0,2})?$/ : /^\d{0,100}(?:\,\d{0,2})?$/;
        if (!regex.test(evt.key)) evt.preventDefault();

    }

    updateInputValue(currInputValue) {
        if (/^(\.|,)+\d/.test(currInputValue)) {
            currInputValue = '0' + currInputValue;
        }
        if (isBetValid(currInputValue, this.props.store)) {
            this.props.store.dispatch(updateOpenBetStake(this.props.betSelection, currInputValue.replace(getDecimalSeparator(this.props.store), '.')));
        }

    }

    formatInputValue(currInputValue, id) {
        //the currInputValue is required for long press, when context menu is triggered, it will put on the input box the value of the currInputValue instead of the formated one
        this.props.openBetFocusCallback(false, undefined, undefined, currInputValue);

        currInputValue = currInputValue.replace(getDecimalSeparator(this.props.store), '.');
        if (currInputValue !== '' && !isNaN(currInputValue)) {
            let storeData = this.props.store.getState();
            let systemLanguage = storeData.vpp.systemLanguage;
            let systemCurrency = storeData.vpp.systemCurrency;
            if (this.props.store != undefined && usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) {
                currInputValue = this.adjustInputValueToBaseIfNoDecimalPlaceEntered(currInputValue, systemCurrency);
            }
            currInputValue = getFormattedCurrency(this.props.store, currInputValue, 2, systemLanguage, systemCurrency, false);
            //this is required to handle countries with commas as decimal separators

            this.updateInputValue(currInputValue);
            let stakeValues = getItem(storeData.vpp.playerUID, DEFAULT_STAKES) || {};
            stakeValues[this.props.betSelection.bets[0].game.channel] = currInputValue;
            setItem(storeData.vpp.playerUID, DEFAULT_STAKES, stakeValues);

        } else {
            document.getElementById(id).value = '';
            currInputValue = '';
            this.setState({
                placeholderHidden: false,
            });
        }

    }

    adjustInputValueToBaseIfNoDecimalPlaceEntered(currInputValue, systemCurrency) {
        if (systemCurrency === GOLD || systemCurrency === SILVER || systemCurrency === JPY) {
            return currInputValue;
        } else if (currInputValue.indexOf('.') === -1) {
            return currInputValue * BASE_VALUE;
        } else {
            return currInputValue;
        }
    }

    onFocus() {
        this.props.openBetFocusCallback(true, this.props.betSelection, 'stakeInput_' + this.props.index);
        this.setState({
            placeholderHidden: true,
        });

    }

    _preventRoolbackToPreviousAmount(event) {
        event.preventDefault();
        event.stopPropagation();
    }

}

export default connect(mapStateToProps)(OpenBet);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/openBet.js